import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import { isDate, useWPAjax } from "../../../../../wp-utils/v1";
import "react-datepicker/dist/react-datepicker.css";
import { produce } from "immer";

const NewJob = ({ nonce, state, setState, job = null }) => {
  const [data, setData] = useState(job);
  const { data: jobPost, isLoading, saveData, error } = useWPAjax("ajax_request_handler", { nonce, model: "JobPost", method: "new_job_post" }, true);
  const { title, company, details, education_qualification, apx_salary, age_limit, dead_line } = data || {};

  const handleChange = (e) => {
    setData({ ...data, [e.target.id]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    saveData(data);
  };

  useEffect(() => {
    if (!isLoading && !error && jobPost) {
      const newState = produce(state, (draft) => {
        if (data?.id) {
          draft.jobs = draft.jobs.map((job) => {
            return job.id === data?.id ? jobPost : job;
          });
        } else {
          draft.jobs.push(jobPost);
        }
      });
      setState(newState);
      if (!data?.id) {
        setData({});
      }
    }
  }, [isLoading]);

  useEffect(() => {
    if (!isLoading && !error) {
      if (!data?.id) {
        setData({});
      }
    }
  }, [isLoading, error]);

  return (
    <form className="p-5 bg-white dark:bg-gray-900 antialiased " onSubmit={handleSubmit}>
      <div className="mb-6">
        <label htmlFor="title" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Title
        </label>
        <input
          onChange={handleChange}
          type="text"
          id="title"
          value={title || ""}
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          placeholder="Title"
          required=""
        />
      </div>
      <div className="mb-6">
        <label htmlFor="company" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Company
        </label>
        <input
          onChange={handleChange}
          type="text"
          id="company"
          value={company || ""}
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          required=""
        />
      </div>
      <div className="mb-6">
        <label htmlFor="education_qualification" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Education Qualification
        </label>
        <input
          onChange={handleChange}
          type="text"
          value={education_qualification || ""}
          id="education_qualification"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          required=""
        />
      </div>
      <div className="mb-6">
        <label htmlFor="apx_salary" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Approximate Salary
        </label>
        <input
          onChange={handleChange}
          type="text"
          value={apx_salary || ""}
          id="apx_salary"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          required=""
        />
      </div>
      <div className="mb-6">
        <label htmlFor="age_limit" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Age Limit
        </label>
        <input
          onChange={handleChange}
          type="number"
          id="age_limit"
          value={age_limit || ""}
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          required=""
        />
      </div>
      <div className="mb-6 ">
        <label htmlFor="dead_line" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Deadline
        </label>
        <DatePicker
          onChange={(dead_line) => {
            setData({ ...data, dead_line: isDate(dead_line) ? new Date(dead_line).toISOString().slice(0, 19).replace("T", " ") : new Date() });
          }}
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          className="input_text w-full"
          shouldCloseOnSelect={true}
          dateFormat="dd/MM/yyyy"
          selected={isDate(dead_line) ? new Date(dead_line) : new Date()}
        />
      </div>

      <div className="mb-6">
        <label htmlFor="age_limit" className="block mb-2 text-sm font-medium text-gray-900 ">
          Details
        </label>
        <textarea
          onChange={handleChange}
          id="details"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400  dark:focus:ring-blue-500 dark:focus:border-blue-500"
          required=""
        >
          {details}
        </textarea>
      </div>
      <div className="flex justify-between">
        {jobPost && !isLoading && <p className="text-green-700">Success!</p>}
        {error && <p className="text-red-700">{error}</p>}
        <span></span>
        <button
          disabled={isLoading}
          type="submit"
          className="flex text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 disabled:opacity-75"
        >
          {isLoading && (
            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx={12} cy={12} r={10} stroke="currentColor" strokeWidth={4} />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          )}
          {job?.id ? "Update" : "Submit"}
        </button>
      </div>
    </form>
  );
};

export default NewJob;
